import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export const SavedGroups = ({ segments, onSegmentsChanged }) => {
  const deleteSegment = async (s) => {
    try {
      await api.delete(`/segments/${s.id}`);
      toast.success(`Segment "${s.name}" removed.`);
      onSegmentsChanged();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-3"><CardTitle className="font-serif text-xl">Saved groups</CardTitle></CardHeader>
      <CardContent className="p-0">
        <Table data-testid="segments-table">
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead className="text-right">Customers</TableHead><TableHead className="hidden sm:table-cell">Created by</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {segments.length === 0 ? (
              <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground">No saved groups yet.</TableCell></TableRow>
            ) : segments.map((s) => (
              <TableRow key={s.id} data-testid={`segment-row-${s.id}`}>
                <TableCell className="py-4 font-medium">{s.name}</TableCell>
                <TableCell className="text-right">{s.count}</TableCell>
                <TableCell className="hidden sm:table-cell text-muted-foreground">{s.created_by}</TableCell>
                <TableCell className="text-right">
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      <Button variant="ghost" size="sm" className="text-destructive hover:text-destructive" data-testid={`delete-segment-${s.id}`}><Trash2 className="h-4 w-4" /></Button>
                    </AlertDialogTrigger>
                    <AlertDialogContent>
                      <AlertDialogHeader>
                        <AlertDialogTitle className="font-serif">Remove the group "{s.name}"?</AlertDialogTitle>
                        <AlertDialogDescription>This only removes the saved group — no customers are affected.</AlertDialogDescription>
                      </AlertDialogHeader>
                      <AlertDialogFooter>
                        <AlertDialogCancel>Keep it</AlertDialogCancel>
                        <AlertDialogAction onClick={() => deleteSegment(s)} data-testid={`confirm-delete-segment-${s.id}`}>Yes, remove it</AlertDialogAction>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialog>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
